import React from 'react';
import { connect } from 'react-redux';
import toastr from 'toastr';
import { createNode, deleteNode, updateNode, uploadFloorplanView, setParent } from 'actions/node';
import { fetchCustomerOverview } from 'actions/overview';
import MainMenu from 'components/common/mainmenu';
import Tree from 'components/pages/locations/settings/tree';
import AddLocationForm from 'components/pages/locations/modalformcomponents/addlocationform';
import AddFloorplanForm from 'components/pages/locations/modalformcomponents/addfloorplanform';
import EditLocationForm from 'components/pages/locations/modalformcomponents/editlocationform';
import DeleteLocationForm from 'components/pages/locations/modalformcomponents/deletelocationform';
import ConfirmDeleteLocationForm from 'components/pages/locations/modalformcomponents/confirmdeletelocation';
import StickyMenu from "components/common/stickymenu"
import StatsMenu from "components/common/statsmenu"
export class LocationSettings extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.openAddLocationForm = this.openAddLocationForm.bind(this);
        this.confirmDeleteLocation = this.confirmDeleteLocation.bind(this);
        this.state = {
            currentNode: {},
            isAddingLocation: false,
            isEditing: false,
            isAddingFloorplan: false,
            isEditingLocation: false,
            isDeletingLocation: false,
            isConfirmingDeleteLocation: false,
            type: 'only'
        };
    }

    openDeleteLocationForm(node) {
        this.setState({ isDeletingLocation: true, currentNode: node });

    }

    closeDeleteLocationForm() {
        this.setState({ isDeletingLocation: false });
    }
    openEditLocationForm(node) {
        this.setState({ isEditingLocation: true, currentNode: node });
    }

    closeEditLocationForm() {
        this.setState({ isEditingLocation: false });
    }

    openAddFloorplanForm(node) {
        this.setState({ isAddingFloorplan: true, currentNode: node });
    }

    closeAddFloorplanForm() {
        this.setState({ isAddingFloorplan: false });
    }

    openAddLocationForm(node) {
        this.setState({ isAddingLocation: true, currentNode: node });
    }

    closeAddLocationForm() {
        this.setState({ isAddingLocation: false });
    }

    openEditDropdown() {
        this.setState({ isEditing: true });
    }

    closeEditDropdown() {
        this.setState({ isEditing: false });
    }

    openConfirmDeleteLocationForm() {
        this.setState({ isConfirmingDeleteLocation: true });
    }

    closeConfirmDeleteLocationForm() {
        this.setState({ isConfirmingDeleteLocation: false });
    }

    addLocation(parent, state) {
        var type = "location";
        switch (state.option) {
            case "Multi":
                type = "multicountry";
                break;
            case "Customer":
                type = "customer";
                break;
            default:
                type = "location";
        }

        let newNode = {
            info: {
                name: state.name,
                details: {},
                location: state.timezone
            },
            type: type
        }
        if (state.name.length == 0) {
            toastr.error("Name must not be empty.")
        }

        if (state.location == 'sub') {
            this.props.dispatch(createNode(parent.id, newNode)).then(() => {
                this.props.dispatch(fetchCustomerOverview());
                toastr.success(`Add ${newNode.info.name} successfully`)
            }).catch(error => {
                toastr.error(error);
            });
        } else {
            if (parent.type == "multicountry") {
                toastr.error("Cannot add top location above a multi-country location.")
                return;
            }
            newNode.type = 'location';
            this.props.dispatch(createNode(parent.parent.id, newNode)).then((response) => {
                this.props.dispatch(setParent(parent.id, response.id)).then(() => {
                    this.props.dispatch(fetchCustomerOverview());
                    toastr.success(`Add ${newNode.info.name} successfully`)
                }).catch(error => {
                    toastr.error(error);
                });
            }).catch(error => {
                toastr.error(error);
            });
        }
    }


    deleteLocation(node, type) {
        if (type == 'all') {
            this.setState({ type: 'all' });
        }
        else {
            this.setState({ type: 'only' });
        }
        this.closeDeleteLocationForm();
        this.openConfirmDeleteLocationForm();
    }

    confirmDeleteLocation(node) {
        if (this.state.type == 'all' || node.children.length == 0) {
            this.props.dispatch(deleteNode(node)).then(() => {
                this.props.dispatch(fetchCustomerOverview());
                toastr.error(`${node.info.name} has been deleted`);
            })
                .catch(error => {
                    toastr.error(error);
                });
        }
        else {
            let parent = node.parent;
            let length = node.children.length;
            for (let i = 0; i < length; i++) {
                this.props.dispatch(setParent(node.children[i].id, parent.id)).then(() => {
                    if (i == (length - 1)) {
                        this.props.dispatch(deleteNode(node)).then(() => {
                            this.props.dispatch(fetchCustomerOverview());
                            toastr.error(`${node.info.name} has been deleted`);
                        })
                            .catch(error => {
                                toastr.error(error);
                            });
                    }
                })
                    .catch(error => {
                        toastr.error(error);
                    });
            }
        }
    }

    updateLocation(node, state) {
        if (!state.name && !state.timezone && !state.country) {
            toastr.info("Nothing changed");
        }
        else {
            var newNode = {
                id: node.id,
                info: {
                    name: state.name,
                    location: state.timezone
                }
            };
            if (state.country == "Multi") {
                newNode.info.type = "multicountry"
            }
            this.props.dispatch(updateNode(newNode)).then(() => {
                this.closeEditLocationForm();
            });
        }

    }

    uploadImage(node, image, state) {
        if (!node.info.hasfloorplan && state.hasfloorplan && state.useownfp && !image) {
            return [false, "This location doesn't have any floorplan yet. Please upload a new one !"]
        }
        if (image) {
            this.props.dispatch(uploadFloorplanView(node, image, state.type)).then(() => {
                this.closeAddFloorplanForm();
            });
            return [true, ""];
        } else {
            var hasfloorplan = state.hasfloorplan;
            var useownfp = hasfloorplan && state.useownfp;
            var newNode = {
                id: node.id,
                info: {
                    name: node.info.name,
                    hasfloorplan: hasfloorplan,
                    useownfp: useownfp
                },
                type: state.type
            }
            this.props.dispatch(updateNode(newNode)).then(() => {
                this.closeAddFloorplanForm();
            });
            return [true, ""];
        }
    }
    render() {
        return (
            <div className="location-settings-page overwrite--modal--depth">
                <StickyMenu
                    withStickyHeader={false}
                >
                    <MainMenu
                        overviewIsActive={false}
                        comparisonIsActive={false}
                        onlyLeftMenu={true}
                    />
                    <StatsMenu leftItemBold="Location Settings" />
                </StickyMenu>
                <div className="page-content page-content_padding-modifier">
                    <div className="display--flex__flex--center">
                        <div className="white-box-container box--shadow bg--white" style={{ width: "50%" }}>
                            <div className="display--flex clearfix">
                                <div className="display--flex__flex--start--center">
                                    <h3>{this.props.tree.info.name}</h3>
                                </div>
                                <div className="flex__end">
                                    <a onClick={() => this.openAddLocationForm(this.props.tree)}
                                        className="button btn--green add--loc--btn__icon--text " data-toggle="modal">
                                        <span  className="font-icon icon-addicon" />
                                        Add {this.props.tree.type == "root" ? "Customer" : "Location"}
                                    </a>
                                </div>
                            </div>
                            <Tree openAddLocationForm={this.openAddLocationForm.bind(this)} style="location__list clearfix"
                                tree={this.props.tree}
                                openAddFloorplanForm={this.openAddFloorplanForm.bind(this)}
                                closeAddFloorplanForm={this.closeAddFloorplanForm.bind(this)}
                                openEditLocationForm={this.openEditLocationForm.bind(this)}
                                closeEditLocationForm={this.closeEditLocationForm.bind(this)}
                                openDeleteLocationForm={this.openDeleteLocationForm.bind(this)}
                                closeDeleteLocationForm={this.closeDeleteLocationForm.bind(this)}
                                location={this.props.location}
                            />
                            {this.state.isAddingLocation &&
                                <AddLocationForm
                                    submit={this.addLocation.bind(this)}
                                    node={this.state.currentNode}
                                    tree={this.props.tree}
                                    isAddingLocation={this.state.isAddingLocation}
                                    closeAddLocationForm={this.closeAddLocationForm.bind(this)} />
                            }
                            {this.state.isAddingFloorplan && <AddFloorplanForm submit={this.uploadImage.bind(this)} node={this.state.currentNode} isAddingFloorplan={this.state.isAddingFloorplan} closeAddFloorplanForm={this.closeAddFloorplanForm.bind(this)} />}
                            {this.state.isEditingLocation && <EditLocationForm submit={this.updateLocation.bind(this)} node={this.state.currentNode} isEditingLocation={this.state.isEditingLocation} closeEditLocationForm={this.closeEditLocationForm.bind(this)} />}
                            {this.state.isDeletingLocation && <DeleteLocationForm submit={this.deleteLocation.bind(this)} node={this.state.currentNode} isDeletingLocation={this.state.isDeletingLocation} closeDeleteLocationForm={this.closeDeleteLocationForm.bind(this)} />}
                            {this.state.isConfirmingDeleteLocation && <ConfirmDeleteLocationForm submit={this.confirmDeleteLocation.bind(this)} type={this.state.type == 'all'} node={this.state.currentNode} isConfirmingDeleteLocation={this.state.isConfirmingDeleteLocation} closeConfirmDeleteLocationForm={this.closeConfirmDeleteLocationForm.bind(this)} />}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.myAccountReducer.user,
        currentSensor: state.nodeReducer.map,
        tree: state.overviewReducer.customerOverview
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LocationSettings);



// WEBPACK FOOTER //
// ./src/components/pages/locations/settings/index.jsx